var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 35,
    viewBox: "0 0 45 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.82143 35H40.1786C41.4575 35 42.6836 34.4972 43.588 33.6023C44.492 32.707 45 31.4933 45 30.2273V4.77273C45 3.50673 44.492 2.293 43.588 1.39773C42.6836 0.502836 41.4575 0 40.1786 0H4.82143C3.54251 0 2.3164 0.502836 1.41199 1.39773C0.507967 2.29297 0 3.50673 0 4.77273V30.2273C0 31.4933 0.507967 32.707 1.41199 33.6023C2.31637 34.4972 3.54251 35 4.82143 35ZM16.8107 18.9C18.3181 20.3961 20.3651 21.237 22.4999 21.237C24.6347 21.237 26.6817 20.3961 28.1891 18.9L41.7855 5.42545V29.5755L31.6771 19.5527L29.3947 21.812L39.5197 31.8184H5.48045L15.6054 21.812L13.3231 19.5527L3.21465 29.5755V5.42545L16.8107 18.9ZM5.4799 3.18182H39.5192L25.9062 16.6409H25.9066C25.0026 17.5347 23.7771 18.0365 22.4993 18.0365C21.2214 18.0365 19.996 17.5348 19.0919 16.6409L5.4799 3.18182Z",
    fill: "black",
    fillOpacity: 0.29
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.f3500f408846d470210ec80bb07683ed.svg";
export { ForwardRef as ReactComponent };